import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format,parse } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Autocomplete from "@material-ui/lab/Autocomplete";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	// modal: {
	// 	display: "flex",
	// 	alignItems: "center",
	// 	justifyContent: "center",
	// },
	viewMore: {
    marginTop: 4,
    background: "none",
    border: "none",
    color: "#339933",
    cursor: "pointer",
    padding: 0,
    fontSize: 12,
  },
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999,
  },
  modal: {
    background: "#fff",
    padding: 20,
    borderRadius: 6,
    minWidth: 500,
    maxHeight: "70vh",
    overflowY: "auto",
  },
}));



const JcPortalPackageSales = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [transaction_no, setTransaction_no] = useState('');
	const [package_code, setPackage_code] = useState('');
	const [downloadFlag, setDownloadFlag] = useState(false);

	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

const minSelectableDate = new Date(2025, 4, 6);

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	const dataFilter = async () => {
		setDataLoaded(false);
        await axios.get(
			process.env.REACT_APP_API_URL+'packagesales_transaction_table', {
            params:{
				// date_from:2020-01-01
				// date_to:2021-01-30
				// jc_u_idno:DAVAOHQ
				// //transaction_no:PPS_000000010
				// package_code:STARTUP
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_u_idno: useridNo,  
				transaction_no: transaction_no,
				package_code: package_code,
            }
        }).then((res)=>{
			setPosts(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		})
		setDataLoaded(true);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const packageProps = [
		{
			id:"STARTUP",
			description:"1 Startup Account"
		},
		{
			id:"PLATINUM",
			description:"1 Platinum Account"
		},
		{
			id:"FH_PLATINUM",
			description:"1 Platinum Account (Cash is King)"
		},
		{
			id:"SCK_PLATINUM",
			description:"1 Platinum Account (Super Cash is King)"
		},
		{
			id:"TOKTOK_PLATINUM",
			description:"1 toktok Platinum Account (Cash is King)"
		},
		{
			id:"SCK_TOKTOK_PLATINUM",
			description:"1 toktok Platinum Account (Super Cash is King)"
		},
	];

	const selectPackageProps = {
		options: packageProps,
		getOptionLabel: (option) => option.description,
	};
		const columns_old = [
		{
			name: "trandate",
			label: "Date",
		},
		{
			name: "idno",
			label: "ID No",
		},
		{
			name: "delivered_to",
			label: "Sold To",
		},
		{
			name: "package_name",
			label: "Promo Code",
		},
		{
			name: "package_amount",
			label: "Amount",			
			options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "release_date",
			label: "Released Date",
			options: {
				customBodyRenderLite: (dataIndex) => {
					let isreleased =  posts[dataIndex].release_date;
					if(isreleased==="0000-00-00"){
						return(
							<div style={{textAlign:"center"}}>-</div>)
					}else{
							return(
							<div>{isreleased}</div>)
					}
				},
			}
		},
				{
			name: "release_date",
			label: "Released Status",
			options: {
				customBodyRenderLite: (dataIndex) => {
					let isreleased =  posts[dataIndex].release_date;
					if(isreleased==="0000-00-00"){
						return(
							<div style={{textAlign:"center"}}>Not Released</div>)
					}else{
							return(
							<div style={{textAlign:"center"}}>Released</div>)
					}
				},
			}
		},
		{
			name: "action",
			label: "Action",
			options: {
				download: false, //exclude this column in csv export
				customBodyRenderLite: (dataIndex) => {
					let isreleased =  posts[dataIndex].isreleased;
					let waybill_no =  posts[dataIndex].waybill_no;
					let isdelivered =  posts[dataIndex].isdelivered;
					let transaction_no =  posts[dataIndex].transaction_no;
					let hq =  posts[dataIndex].hqcode;
					if(hq != "MAINHQ"){
					if(isreleased===0){
						return(
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
									<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>
								<Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
								{get_cookies('can_process') == 1 ?
									<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/release"}>
										<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}> 
											Release
										</Button>	
									</NavLink> 	
								:null}
								</Grid>
							</Grid>)
					}else{
						if(waybill_no === ""){
							return(
								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={12} lg={12} xl={4}>
										<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
											<Button variant="contained" color="primary">
												View
											</Button>	
										</NavLink> 
									</Grid>
									<Grid item xs={12} sm={6} md={12} lg={12} xl={6}>
									{get_cookies('can_process') == 1 ?
										<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/waybill"}>
											<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}> 
												Enter Waybill
											</Button>	
										</NavLink>
									:null} 	
									</Grid>
								</Grid>)	
						}else{
							if(isdelivered === 1){
								return(
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
											<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
													Print
												</Button>	
											</NavLink> 
										</Grid>
									</Grid>)
							}else{
								return(
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
											<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
													View
												</Button>	
											</NavLink> 
										</Grid>
										<Grid item xs={12} sm={6} md={12} lg={12} xl={6}>
										{get_cookies('can_process') == 1 ?
											<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/deliver"}>
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}> 
													Confirm Delivery
												</Button>	
											</NavLink> 
										:null} 	
										</Grid>
									</Grid>)	
							}
						}
					}
					}else{
return(
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
											<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
													View
												</Button>	
											</NavLink> 
										</Grid>
									</Grid>)	
					}

				},
			},
	 	}
	];

	const SetItemsCell = ({ items = [] }) => {
  const [open, setOpen] = React.useState(false);

  if (!items || items.length === 0) return "-";

  return (
    <>
      {/* Show first item */}
      <div>{items[0]}</div>

      {/* Show button only if more than 1 */}
      {items.length > 1 && (
        <button
          onClick={() => setOpen(true)}
          className={classes.viewMore}
        >
          View more ({items.length - 1})
        </button>
      )}

      {/* Modal */}
      {open && (
		<div className={classes.backdrop}>
		<div className={classes.modal}>
			<h3>Wholesale set items</h3>

      <ul>
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

	<Button    onClick={() => setOpen(false)} variant="contained" color="secondary"> 
		Close
	</Button>	
		</div>
		</div>
      )}
    </>
  );
};

	const columns = [
		{
			name: "trandate",
			label: "Date",
		},
		{
			name: "idno",
			label: "ID No",
		},
		{
			name: "delivered_to",
			label: "Sold To",
		},
		{
			name: "package_name",
			label: "Wholesale Set",
			  options: {
				customBodyRender: (value) => <SetItemsCell items={value} />,
				},
		},
		{
			name: "package_amount",
			label: "Amount",			
			options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "hq",
			label: "Head Quarters",			
			options: {
				setCellProps: value => ({ style: { textAlign: 'left' } }),
			}
		},
		{
			name: "release_date",
			label: "Released Date",
			options: {
				customBodyRenderLite: (dataIndex) => {
					let isreleased =  posts[dataIndex].release_date;
					if(isreleased==="0000-00-00"){
						return(
							<div style={{textAlign:"center"}}>-</div>)
					}else{
							return(
							<div>{isreleased}</div>)
					}
				},
			}
		},
				{
			name: "release_date",
			label: "Released Status",
			options: {
				customBodyRenderLite: (dataIndex) => {
					let isreleased =  posts[dataIndex].release_date;
					if(isreleased==="0000-00-00"){
						return(
							<div style={{textAlign:"center"}}>Not Released</div>)
					}else{
							return(
							<div style={{textAlign:"center"}}>Released</div>)
					}
				},
			}
		},
		{
			name: "action",
			label: "Action",
			options: {
				download: false, //exclude this column in csv export
				customBodyRenderLite: (dataIndex) => {
					let isreleased =  posts[dataIndex].isreleased;
					let waybill_no =  posts[dataIndex].waybill_no;
					let isdelivered =  posts[dataIndex].isdelivered;
					let transaction_no =  posts[dataIndex].transaction_no;
					let hq =  posts[dataIndex].hqcode;
					if(hq != "MAINHQ"){
					if(isreleased===0){
						return(
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
									<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>
								<Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
								{get_cookies('can_process') == 1 ?
									<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/release"}>
										<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}> 
											Release
										</Button>	
									</NavLink> 	
								:null}
								</Grid>
							</Grid>)
					}else{
						if(waybill_no === ""){
							return(
								<Grid container spacing={1}>
									<Grid item xs={12} sm={6} md={12} lg={12} xl={4}>
										<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
											<Button variant="contained" color="primary">
												View
											</Button>	
										</NavLink> 
									</Grid>
									<Grid item xs={12} sm={6} md={12} lg={12} xl={6}>
									{get_cookies('can_process') == 1 ?
										<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/waybill"}>
											<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}> 
												Enter Waybill
											</Button>	
										</NavLink>
									:null} 	
									</Grid>
								</Grid>)	
						}else{
							if(isdelivered === 1){
								return(
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
											<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
													Print
												</Button>	
											</NavLink> 
										</Grid>
									</Grid>)
							}else{
								return(
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
											<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
													View
												</Button>	
											</NavLink> 
										</Grid>
										<Grid item xs={12} sm={6} md={12} lg={12} xl={6}>
										{get_cookies('can_process') == 1 ?
											<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/deliver"}>
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}> 
													Confirm Delivery
												</Button>	
											</NavLink> 
										:null} 	
										</Grid>
									</Grid>)	
							}
						}
					}
					}else{
return(
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
											<NavLink to={"/sales/jcpackagesales-view/"+transaction_no+"/view"}>
												<Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
													View
												</Button>	
											</NavLink> 
										</Grid>
									</Grid>)	
					}

				},
			},
	 	}
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		download: false,  //add this
		print: false, //add this
		viewColumns :false,
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		downloadOptions: {
			filename : 'JcPortalPackageSales.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/WholesaleMenu">
						<h2 className="header-title">Wholesale Set</h2>
					</NavLink>
					<Typography color="textPrimary">JC Portal Wholesale Set</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
									style={{marginTop:"1rem"}}
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
				//  minDate={'2025-05-06'}
                                /> 
                            </Grid>
							<Grid item xs={12} md={5} lg={3} xl={3}>
									<TextField
													id="outlined-required"
													style={{marginTop:"1rem"}}
													label="ID No"
													placeholder="Enter ID No."
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={transaction_no} //to avoid label overlapping bug
													onChange={(e)=>{setTransaction_no(e.target.value)}}
													InputProps={{
														type: 'text',
													  }}
										/>
							</Grid>
							{/* <Grid item xs={12} md={5} lg={3} xl={3}>
									<Autocomplete
												{...selectPackageProps}
												id="auto-complete-2"
												autoComplete
												includeInputInList
												renderInput={(params) => (
													<TextField
														{...params}
														margin="normal"
														label="Release Status"
														variant="outlined"
													/>
												)}onChange={(event, newValue) => {
													if (!newValue == "" || !newValue == null){
														//console.log(newValue.description);
														setPackage_code(newValue.id);
													}
									}}
									/>
							</Grid> */}
                            <Grid item xs={1} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					// <MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
									<h3 className="header-title" style ={{color: "#339933"}}>
									JC Portal Wholesale Set
									</h3>
								</div>
							}
							data={posts}
							columns={format(dateRange.endDate, "yyyy-MM-dd") >="2025-05-06" && format(dateRange.startDate, "yyyy-MM-dd") >="2025-05-06" ?columns:columns_old}
							options={options}
						/>
				//   </MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default JcPortalPackageSales;